import React from "react";
import "../assets/styles/Footer-Link-Content.css";

const TermsOfService = () => {
  return (
    <div className="footer-link-content">
      <h1>TERMS OF SERVICE</h1>

      <section>
        <h3>Product Availability:</h3>
        <p>
          All products listed on our website or in-store are subject to
          availability. We strive to keep our inventory up to date, but
          occasionally items may be out of stock.
        </p>
      </section>

      <section>
        <h3>Pricing:</h3>
        <p>
          Prices of products are subject to change without prior notice.
          However, once you place an order, the price will remain fixed for that
          transaction.
        </p>
      </section>

      <section>
        <h3>Order Confirmation:</h3>
        <ul>
          <li>
            After placing an order, you will receive an email confirming receipt
            of your order. This email will only be an acknowledgment and will
            not constitute acceptance of your order.
          </li>
          <li>
            A contract between us for the purchase of the goods will not be
            formed until your payment has been approved by us and we have
            debited your credit or debit card.
          </li>
        </ul>
      </section>

      <section>
        <h3>Delivery:</h3>
        <p>
          We aim to dispatch all orders within 3 to 4 working days of receiving
          payment. Delivery times may vary depending on your location and other
          factors beyond our control.
        </p>
      </section>

      <section>
        <h3>Returns and Refunds:</h3>
        <ul>
          <li>We want you to be completely satisfied with your purchase.</li>
          <li>
            If you are not satisfied with your purchase for any reason, please
            contact us within 24 hours of receiving your order to arrange for a
            return and refund.
          </li>
        </ul>
      </section>

      <section>
        <h3>Quality Assurance:</h3>
        <ul>
          <li>
            We take great care in sourcing and packaging our products to ensure
            they reach you in perfect condition.
          </li>
          <li>
            However, if you receive a product that is damaged or of
            unsatisfactory quality, please contact us immediately to arrange for
            a replacement or refund.
          </li>
        </ul>
      </section>

      <section>
        <h3>Privacy Policy:</h3>
        <ul>
          <li>
            We respect your privacy and are committed to protecting your
            personal information.
          </li>
          <li>
            Any personal information you provide to us will be used solely for
            the purpose of processing your order and will not be shared with
            third parties.
          </li>
        </ul>
      </section>

      <section>
        <h3>Copyright:</h3>
        <p>
          All content included on our website, such as text, graphics, logos,
          button icons, images, audio clips, digital downloads, data
          compilations, and software, is the property of our company or its
          content suppliers and is protected by international copyright laws.
        </p>
      </section>

      <section>
        <h3>Governing Law:</h3>
        <p>
          These terms and conditions shall be governed by and construed in
          accordance with the laws of India, and any disputes relating to these
          terms and conditions will be subject to the exclusive jurisdiction of
          the courts of Tamil Nadu.
        </p>
      </section>

      <section>
        <h3>Changes to Terms and Conditions:</h3>
        <ul>
          <li>
            We reserve the right to update or modify these terms and conditions
            at any time without prior notice.
          </li>
          <li>
            Your continued use of our website or services following any such
            changes constitutes your acceptance of the new terms and conditions.
          </li>
        </ul>
      </section>

      <section>
        <h3>Shipping:</h3>
        <p>Free shipping on all orders above $999</p>
      </section>
    </div>
  );
};

export default TermsOfService;
